import { VStack, Box, Col, Row } from "@reverb-ui/react";
import { InsightsFeedbackEnum } from "data/constants/constants";
import { panelsInfo } from "helper/panelsHelper";
import { ListCardSkeleton } from "presentation/components/Skeleton/CardSkeleton";
import { SortedTableSkeleton } from "presentation/components/Skeleton/SortedTableSkeleton";
import { SortedTable } from "presentation/components/SortedTable";
import { useContext, useMemo } from "react";
import { MetricCard } from "../../components/MetricCard";
import { ViewPortRankingContext } from "../context-api/ViewPortRankingProvider";
import { ViewPortSizeCell } from "./ViewPortSizeCell";
import PanelContainer from "presentation/components/PanelContainer";

const viewportRankingInfo = panelsInfo.viewportRanking;

export const ViewPortRankingReports = () => {
  const {
    requestParamsIndex,
    viewPortRankingData,
    downloadViewportRankingReport,
    downloadingReports,
    isLoading,
  } = useContext(ViewPortRankingContext);

  const { viewPortRanking } = viewPortRankingData || {};

  const viewPortRankingRow = useMemo(() => {
    return viewPortRanking?.dataRows.map((viewPort) => ({
      viewPortSize: (
        <ViewPortSizeCell tooltipMessage={viewPort.viewPortSize}>
          {viewPort.viewPortSize}
        </ViewPortSizeCell>
      ),
      converted: viewPort.converted,
      visitors: viewPort.visitors,
      bounced: viewPort.bounced,
    }));
  }, [viewPortRanking]);

  return (
    <PanelContainer
      panelId={viewportRankingInfo.htmlId}
      panelName={viewportRankingInfo.description}
      rangeName={viewPortRankingData?.range}
      isLoading={isLoading}
      downloadOptions={{
        onClickGenerateCSV: downloadViewportRankingReport,
        downloadingReports: downloadingReports,
        panelInfo: viewportRankingInfo,
        filterStateIndex: requestParamsIndex,
      }}
    >
      <Row>
        <Col
          col={!isLoading && viewPortRankingData?.cards.length === 0 ? 0 : 3}
        >
          {isLoading ? (
            <ListCardSkeleton
              numberOfCards={1}
              spacingBetween={5}
              hasSubText={true}
              hasRecomendation={true}
            />
          ) : (
            <VStack w="full" spacing={5}>
              {viewPortRankingData?.cards.map((item, index) => (
                <MetricCard
                  key={index}
                  order={item.order}
                  iconName={item.iconTitle}
                  title={item.title}
                  description={item.text}
                  subDescription={item.subText}
                  insight={{
                    message: item.recommendation,
                    feedback:
                      item.outcomes.toLowerCase() as InsightsFeedbackEnum,
                  }}
                />
              ))}
            </VStack>
          )}
        </Col>
        <Col
          col={!isLoading && viewPortRankingData?.cards.length === 0 ? 12 : 9}
        >
          <Box bg="white" w="full" p={6} height="fit-content">
            {isLoading ? (
              <SortedTableSkeleton numberOfColumns={4} />
            ) : (
              <SortedTable
                dataColumns={
                  viewPortRankingData?.viewPortRanking.dataColumns || []
                }
                dataRows={viewPortRankingRow || []}
              />
            )}
          </Box>
        </Col>
      </Row>
    </PanelContainer>
  );
};
